// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/inventari-fisici?societaId=&stato=&depositoId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, numero, anno, data, descrizione, stato, deposito, movimentoRettifica, nRighe }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/depositi?societaId=',
    requestBody: null,
    response: '{ depositi: [{ id, nome, tipo }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/inventari-fisici',
    requestBody: '{ societaId, depositoId, data, descrizione, note }',
    response: '{ success: true, data: { id, righeCreate } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
